const offerMock = {
    'id': '374952473',
    'code': 'azt_rca - 3756177036',
    'premiumBase': '682.88862701273811673153910785',
    'premiumTariffBase': '454',
    'premiumCommercial': '454',
    'directcompensationpremium': '88',
    'premiumCollection': [
        {
            'chc': '0',
            'lineofbusinessclassid': '78',
            'lineofbusinessclassname': '',
            'insuredvalue': '6070000',
            'premium': '454'
        }
    ],
    'bonusMalus': 'B8',
    'instalmentno': '1',
    'averageExpeditureAmount': '55.39',
    'averageExpediturePercent': '12.2',
    'overlappingPolicy': 'false',
    'existingPolicyStartDate': '0001-01-01T00:00:00',
    'existingPolicyEndDate': '0001-01-01T00:00:00',
    'aztCode': '3756177036',
    'name': 'Cotatie polita RCA',
    'price': '454',
    'priceType': 'NET',
    'quantity': 1,
    'vat': 0,
    'info': 'Incheiere polita RCA - cotatia numarul 374952473 pentru autoturism Renault Alege model, serie sasiu VF1R9800X61772762'
};
//http://93.122.177.130:8080/pay/rca?marketing=true&rcaQuotationId=374952473&webrequestid=5fbfc750b432f58a323c652b

const DOM = require('./dom.js');
const ui = require('../ui/index.js');
const termsState = require('../terms/state.js');
const vehicleState = require('../vehicle/state.js');
const insuredState = require('../insured/state.js');
const detailsState = require('../details/state.js');
const offerState = require('../offer/state.js');
const moment = require('moment');
const { useKeys } = require('../common.js');

useKeys(DOM.btnSummaryBack);
useKeys(DOM.btnSummaryNext);

let vehicleLabels = DOM.divSummaryVehicle.querySelectorAll('li>strong');
let insuredTitles = DOM.divSummaryInsured.querySelectorAll('li>span');
let insuredLabels = DOM.divSummaryInsured.querySelectorAll('li>strong');
let insuranceTitles = DOM.divSummaryInsurance.querySelectorAll('li>span');
let insuranceLabels = DOM.divSummaryInsurance.querySelectorAll('li>strong');

const formatAddress = (cityName, district, street, streetNo) => {
    let address = '';
    if (district && district !== '-1')
        address = `${street} ${streetNo}, ${cityName}, Sector ${district}`;
    else
        address = `${street} ${streetNo}, ${cityName}`;
    insuredLabels[4].innerText = address;
};
const formatValidity = (since, validity) => {
    if (!since)
        return;
    let toDate = moment(since).add(validity, 'months').add(-1, 'day');
    insuranceLabels[2].innerText = `${since.format('DD.MM.YYYY')} — ${toDate.format('DD.MM.YYYY')}`;
};

vehicleState.changed(state => {
    let brand = state.brands.find(x => x.Id === state.brand);
    if (brand)
        vehicleLabels[0].innerText = brand.Name;
    vehicleLabels[1].innerText = state.model;
    vehicleLabels[2].innerText = `${state.engineDisplacement} cmc`;
    vehicleLabels[3].innerText = `${state.enginePower} kw`;
    vehicleLabels[4].innerText = state.year;
    vehicleLabels[6].innerText = state.vin;
    vehicleLabels[7].innerText = `${state.maxWeight} kg`;
    vehicleLabels[8].innerText = state.seatNo;
});

detailsState.changed(state => {
    insuredLabels[0].innerText = state.firstName;
    insuredLabels[1].innerText = state.lastName;
    insuredLabels[2].innerText = state.email;
    insuredLabels[3].innerText = state.phone;

    vehicleLabels[5].innerText = state.plateNo;
    formatAddress(insuredState.cityName, insuredState.district, state.street, state.streetNo);
});

insuredState.changed(state => {
    insuredTitles[0].innerText = state.isCompany ? 'Denumire' : 'Prenume';
    insuredLabels[1].parentElement.style.display = state.isCompany ? 'none' : '';

    formatAddress(state.cityName, state.district, detailsState.street, detailsState.streetNo);
    formatValidity(state.date, offerState.validity);
});

offerState.changed(state => {
    insuranceLabels[0].innerText = state.bonusMalus;
    insuranceLabels[1].innerHTML = `${state.price.toLocaleString()} RON`;
    formatValidity(insuredState.date, state.validity);

    let text = 'Plata integrală';
    switch (state.installments) {
        case 2:
            text = 'Plata în două rate';
            break;
        case 4:
            text = 'Plata în patru rate';
            break;
        case 12:
            text = 'Plata în douăsprezece rate';
            break;
    }
    insuranceTitles[3].innerText = text;

    insuranceLabels[4].querySelector('i').className = state.hasDD ? 'icon-check' : 'icon-sc-close';
});

DOM.btnSummaryBack.addEventListener('click', () => {
    ui.state.slide = [3, 0];
});
DOM.btnSummaryNext.addEventListener('click', async () => {
    if (ui.state.isLoading)
        return;

    ui.state.loaderText = 'Aproape am terminat, te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        let req = {
            vin: vehicleState.vin,
            county: insuredState.county,
            city: insuredState.cityCode,
            postalCode: insuredState.postalCode,
            startDate: insuredState.date.format('YYYY-MM-DD'),
            insurancePeriodInMonths: offerState.validity,
            insuranceInstalmentNo: offerState.installments,
            isRegistered: true,
            isLeasing: false,
            isTaxi: vehicleState.isTaxi,
            isDirectCompensation: offerState.hasDD,
            isLocomotorDeficiencyVehicle: false,
            extraCoverage: false,
            vehicleClass: vehicleState.class,
            vehicleBrand: vehicleState.brand,
            vehicleType: vehicleState.model,
            vehicleMaxWeight: vehicleState.maxWeight,
            vehicleYear: vehicleState.year,
            vehicleSeatNo: vehicleState.seatNo,
            vehicleEnginePower: vehicleState.enginePower,
            vehicleEngineDisplacement: vehicleState.engineDisplacement,
            vehicleEnergySource: vehicleState.energySource,
            street: detailsState.street,
            streetNo: detailsState.streetNo,
            email: detailsState.email,
            vehiclePlateNo: detailsState.plateNo
        };
        let phone = detailsState.phone;
        if (detailsState.phone.startsWith('07'))
            phone = `004${phone}`;
        req.phone = phone;
        req.mobile = phone;

        if (insuredState.city == 1638) {
            req.district = insuredState.district;
        }
        if (insuredState.isCompany) {
            req.cui = insuredState.cnp;
            req.companyName = detailsState.firstName;
        } else {
            req.cnp = insuredState.cnp;
            req.firstName = detailsState.firstName;
            req.lastName = detailsState.lastName;
        }

        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/offer/web?requestId=${ui.state.flowId}`, {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        let json = await response.json();
        if (json.body && !response.ok) {
            let faultstring = json.body.match(new RegExp('(<faultstring.+">)(.+(?=</faultstring))', 'im'));
            if (faultstring && faultstring.length > 0) {
                faultstring = faultstring[faultstring.length - 1];

                ui.state.isLoading = false;
                ui.notyf.error(faultstring);
                return;
            }
        }

        if (!response.ok)
            throw new Error('bad request');

        window.location = `${process.env.API_URL}/pay/rca?marketing=${termsState.acceptPersonalData.toString()}&rcaQuotationId=${json.id}&webrequestid=${ui.state.flowId}`;
    } catch (err) {
        ui.state.isLoading = false;
        ui.notyf.error('Ne pare rău, am întâmpinat o eroare');
        console.error(err);
    }
});

module.exports.DOM = DOM;
